"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filter_dto_builder_1 = require("./filter-dto-builder");
var top_filter_dto_1 = require("../dto/top-filter-dto");
var is_filter_dto_1 = require("../dto/is-filter-dto");
var category_range_filter_dto_1 = require("../dto/category-range-filter-dto");
var time_period_filter_dto_1 = require("../dto/time-period-filter-dto");
var in_filter_dto_1 = require("../dto/in-filter-dto");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var contains_filter_dto_1 = require("../dto/contains-filter-dto");
var starts_with_filter_dto_1 = require("../dto/starts-with-filter-dto");
var is_current_user_filter_dto_1 = require("../dto/is-current-user-filter-dto");
/**
 * Created by Hayk.Andriasyan on 5/25/2017.
 */
var CategoryItem = /** @class */ (function () {
    function CategoryItem(parentOperator, categoryPathHolderId) {
        this.isExcluded = false;
        this.isHidden = false;
        this.parentOperator = parentOperator;
        this.categoryPathHolderId = categoryPathHolderId;
    }
    CategoryItem._formatDate = function (date) {
        var day = ('0' + date.getDate()).slice(-2);
        var month = ('0' + (date.getMonth() + 1)).slice(-2);
        var year = date.getFullYear();
        return year + "-" + month + "-" + day;
    };
    CategoryItem.prototype.addFilterToParentOperator = function () {
        this.parentOperator.addFilter(this.getFilter());
    };
    CategoryItem.prototype.in = function (values) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(values);
        var valuesArray = Array.from(values);
        if (valuesArray.length === 0) {
            return this.parentOperator;
        }
        var filterType = filter_dto_builder_1.FilterDtoBuilder.IN;
        if (valuesArray.length === 1 && (valuesArray[0] === null || typeof valuesArray[0] === 'undefined')) {
            filterType = filter_dto_builder_1.FilterDtoBuilder.UNSPECIFIED;
        }
        var filter = new in_filter_dto_1.InFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filterType, this.categoryPathHolderId);
        filter.values = filter.values.concat(valuesArray);
        return this._getParentOperator(filter);
    };
    CategoryItem.prototype.isCurrentUser = function () {
        var filter = new is_current_user_filter_dto_1.IsCurrentUserFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filter_dto_builder_1.FilterDtoBuilder.IS_CURRENT_USER, this.categoryPathHolderId);
        return this._getParentOperator(filter);
    };
    CategoryItem.prototype.isCurrent = function () {
        var filter = new time_period_filter_dto_1.TimePeriodFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filter_dto_builder_1.FilterDtoBuilder.IS_CURRENT, this.categoryPathHolderId, 0);
        return this._getParentOperator(filter);
    };
    CategoryItem.prototype.isLast = function (value) {
        var filter = new time_period_filter_dto_1.TimePeriodFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filter_dto_builder_1.FilterDtoBuilder.IS_LAST, this.categoryPathHolderId, value);
        return this._getParentOperator(filter);
    };
    CategoryItem.prototype.isNext = function (value) {
        var filter = new time_period_filter_dto_1.TimePeriodFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filter_dto_builder_1.FilterDtoBuilder.IS_NEXT, this.categoryPathHolderId, value);
        return this._getParentOperator(filter);
    };
    CategoryItem.prototype.not = function () {
        this.isExcluded = !this.isExcluded;
        return this;
    };
    CategoryItem.prototype.getFilter = function () {
        this.filter.excluded = this.isExcluded;
        this.filter.isHiddenForUser = this.isHidden;
        return this.filter;
    };
    CategoryItem.prototype.between = function (from, to) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(from);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(to);
        var fromValue = from.toString();
        var toValue = to.toString();
        if (typeof from !== 'number') {
            fromValue = CategoryItem._formatDate(from);
            toValue = CategoryItem._formatDate(to);
        }
        return this._createCategoryDateRangeFilter(filter_dto_builder_1.FilterDtoBuilder.BETWEEN_DATES, fromValue, toValue, true);
    };
    CategoryItem.prototype.before = function (start) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(start);
        var valueTo = typeof start === 'number' ? start.toString() : CategoryItem._formatDate(start);
        return this._createCategoryDateRangeFilter(filter_dto_builder_1.FilterDtoBuilder.BEFORE, null, valueTo, false);
    };
    CategoryItem.prototype.onOrBefore = function (start) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(start);
        var valueTo = typeof start === 'number' ? start.toString() : CategoryItem._formatDate(start);
        return this._createCategoryDateRangeFilter(filter_dto_builder_1.FilterDtoBuilder.ON_OR_BEFORE, null, valueTo, true);
    };
    CategoryItem.prototype.after = function (end) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(end);
        var valueFrom = typeof end === 'number' ? end.toString() : CategoryItem._formatDate(end);
        return this._createCategoryDateRangeFilter(filter_dto_builder_1.FilterDtoBuilder.AFTER, valueFrom, null, false);
    };
    CategoryItem.prototype.onOrAfter = function (end) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(end);
        var valueFrom = typeof end === 'number' ? end.toString() : CategoryItem._formatDate(end);
        return this._createCategoryDateRangeFilter(filter_dto_builder_1.FilterDtoBuilder.ON_OR_AFTER, valueFrom, null, true);
    };
    CategoryItem.prototype.is = function (date) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(date);
        var dateValue = typeof date === 'number' ? date.toString() : CategoryItem._formatDate(date);
        var filter = new is_filter_dto_1.IsFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filter_dto_builder_1.FilterDtoBuilder.IS, this.categoryPathHolderId, dateValue);
        return this._getParentOperator(filter);
    };
    CategoryItem.prototype.top = function (measurePathHolderId, topCount) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(measurePathHolderId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(topCount);
        var filter = new top_filter_dto_1.TopFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filter_dto_builder_1.FilterDtoBuilder.TOP, this.categoryPathHolderId, topCount, measurePathHolderId);
        return this._getParentOperator(filter);
    };
    CategoryItem.prototype.contains = function (pattern) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(pattern);
        var filter = new contains_filter_dto_1.ContainsFilterDto(this.categoryPathHolderId, pattern);
        return this._getParentOperator(filter);
    };
    CategoryItem.prototype.startsWith = function (prefix) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(prefix);
        var filter = new starts_with_filter_dto_1.StartsWithFilterDto(this.categoryPathHolderId, prefix);
        return this._getParentOperator(filter);
    };
    CategoryItem.prototype.isHiddenFromUser = function (isHidden) {
        this.isHidden = isHidden;
        return this;
    };
    CategoryItem.prototype._createCategoryDateRangeFilter = function (filterType, valueFrom, valueTo, inclusive) {
        return this._getParentOperator(new category_range_filter_dto_1.CategoryRangeFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filterType, this.categoryPathHolderId, valueFrom, valueTo, inclusive));
    };
    CategoryItem.prototype._getParentOperator = function (filter) {
        this.filter = filter;
        this.addFilterToParentOperator();
        return this.parentOperator;
    };
    return CategoryItem;
}());
exports.CategoryItem = CategoryItem;
//# sourceMappingURL=category-item.js.map